export function Logo({ size = 28, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="haki-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M50 4 L96 50 L50 96 L4 50 Z" fill="#141414" stroke="none" />
        <path d="M50 4 L96 50 L50 96 L4 50 Z" fill="none" stroke="#D3172B" strokeWidth="6"
          strokeDasharray="34 300" strokeLinecap="square" />
        <path d="M50 26 L74 50 L50 74 L26 50 Z" fill="#D3172B" />
      </svg>
      {showText && (
        <div className="leading-none">
          <span className="block font-bold text-lg tracking-tight">HAKI</span>
          <span className="block text-[9px] font-medium tracking-overline text-muted-foreground -mt-0.5">
            CREDIT
          </span>
        </div>
      )}
    </div>
  );
}
